import * as types from './mutation-types'
import ClientDB from '@/rahmen/clientDB'
import conf from '@/rahmen/conf'

export const loadLoginInfo = ({ commit }) => {
  console.log('users.actions.loadLoginInfo')
  return new Promise((resolve, reject) => {
    const db = new ClientDB(conf.loginInfoStoreName)
    db.get(0).then((data) => {
      console.log(data)
      if (data === undefined || data.value === undefined) {
        reject(data)
        return
      }
      commit(types.SAVE_LOGIN_INFO, data.value)
      resolve()
    }).catch((e) => {
      reject(e)
    })
  })
}

export const flushUserInfo = ({ commit }) => {
  commit(types.SAVE_LOGIN_INFO, null)
}

export const tryLogin = ({ commit }, userInfo) => {
  console.log(types.SAVE_LOGIN_INFO)
  // APIによる認証
  return new Promise((resolve) => {
    commit(types.SAVE_LOGIN_INFO, userInfo)
    const db = new ClientDB(conf.loginInfoStoreName)
    db.register(0, userInfo)
    resolve()
  })
}

export const setGoingToUrl = ({ commit }, url) => {
  commit(types.SAVE_GOINGTOURL, url)
}
